module.exports = __webpack_public_path__ + "img/PFE.88f49af0.png";